import React from 'react';

/**
 * 將字串中用 *...* 包起來的文字轉換成 <strong> 包裹
 * 假設文字只用 *xxx* 來表示粗體
 */
export function renderBoldText(text: string): React.ReactNode {
    // 用正則表達式找出所有 *...* 片段
    // 解釋：
    //   \*         匹配 '*' 字符
    //   (.*?)      非貪婪匹配，盡可能少的匹配中間內容
    //   \*         再匹配另一個 '*' 字符
    const pattern = /\*(.*?)\*/g;
    const segments: React.ReactNode[] = [];
    let lastIndex = 0;
    let match;
    let i = 0;

    while ((match = pattern.exec(text)) !== null) {
        const matchStart = match.index;
        const matchEnd = pattern.lastIndex;
        // match[1] 就是 *xxx* 中間的文字 (xxx)
        const boldContent = match[1];

        // 先把這次匹配之前的普通文字 push 進陣列
        segments.push(text.slice(lastIndex, matchStart));

        // 再把中間文字用 <strong> 包起來
        segments.push(<strong key={i++}>{boldContent}</strong>);

        // 更新 lastIndex，下一回合就從 matchEnd 之後繼續找
        lastIndex = matchEnd;
    }

    // 最後把剩下的文字（在最後一個 *...* 之後的部分）push 進去
    segments.push(text.slice(lastIndex));

    // 用 React.Fragment 或 <>{}</> 包起來
    return <>{segments}</>;
}
